<template>
  <div class="animated fadeIn">     
    <b-row>
      <b-col md="12">
<!--          <b-breadcrumb :items="breadcrumbs"/>       
 -->        <b-card>
          <div slot="header">
            <strong>Available Zones</strong>
            <div class="card-header-actions" >
                         <router-link
        to="/zonemaster"
      > <button class="btn btn-sm btn-primary mr-4 btn-pill"   type="button">click here for zone master</button> </router-link>                
              <!-- <button class="btn btn-sm btn-primary mr-4 btn-pill" v-on:click="rackadd()"  type="button">Add New Pincode</button>
               <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button"><i class="fa fa-refresh"></i></button> -->
            </div>
          </div>

         
          <!-- <div id="addrack"  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;" class="mb-1">
              <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                <b-row> 
                  <b-col md="12">
                    <div class="form-group row">
                       <label class="col-md-3 col-form-label" for="hf-email">Zone Name</label>
                      <div class="col-md-4">
                        <b-form-input class="form-control" type="text" name="rackno" v-model="rackno" v-validate="'required|alpha_num|min:3|max:30'"placeholder="Enter Zone Name" :class="{'input': true, 'text-danger': errors.has('form-1.rackno') }"  >
                       </b-form-input>
                       <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('rackno')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.rackno')" class="help text-danger">{{ errors.first('form-1.rackno') }}</span>
                      </b-input-group>
                      </div>
                    </div>   
                    <div class="form-group row">
                       <label class="col-md-3 col-form-label" for="hf-email">Pin Code</label>
                      <div class="col-md-4">
                        <ejs-multiselect id='multiselect' placeholder="Select Pin Codes" v-model="value2" :dataSource='options'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
></ejs-multiselect>
                      </div>
                    </div>                      
                  </b-col>
                
                  <b-col sm="2">
                    <b-button variant="primary" size="md" type="submit">Save</b-button>
                  </b-col>
                </b-row>  
              </b-form>
          </div> -->
            <!-- <b-row class="mb-4">          
                <b-col md="4" class="my-1">
                  <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                    <b-input-group>
                      <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="4" class="my-1">
                  <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
                    <b-input-group>
                      <b-form-select v-model="sortBy" :options="sortOptions">
                        <option slot="first" :value="null">-- none --</option>
                      </b-form-select>
                      <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
                        <option :value="false">Asc</option> <option :value="true">Desc</option>
                      </b-form-select>
                    </b-input-group>
                  </b-form-group>
                </b-col>             
                <b-col md="4" class="my-1">
                  <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>            
            </b-row>   -->
            <div id="overlay" >
             <div class="loader"></div>
           </div>
               <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
               <b-button v-if="this.totalRows >0"  variant="primary" size="md" @click="downloadCSV">Download </b-button> 
              </b-col>
              <b-col sm="12" >  
          <b-table show-empty stacked="md"  :items="items" :busy="isBusy"    :current-page="currentPage"  :fields="fields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  

        
          </b-table>
        </b-col>
          <b-col md="12" class="my-1 " v-if="this.totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>    
         <!--  <div >
            <span style=" width: 75px; float: left; background-color: lightgray; text-align: center; margin-right: 5px; margin-bottom: 2px; padding: 2px;" v-for="item in items">{{item.mapping_locality_id}}</span>

          </div> -->
          <div v-if="this.totalRows < 0">
            <h1>No records found</h1>
          </div>
        

        </b-card>
       
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
  name: 'PinCodes', 
  data: function() {
    return {
      name: 'PinCodes',
      isBusy: false,
      breadcrumbs: [{
        text: 'Dashboard',
        href: '/dashboard'
      },{
        text: 'Available PinCodes',
        active: true
      }],
      add: true,
      rackno:'',           
      items:[],
     fields: [
          // { key: 'id', label: 'Zone Name', sortable: true, sortDirection: 'desc' },
          { key: 'zone_name', label: 'Zone Name', sortable: true},
          { key: 'locality_name', label: ' Locaity Name', sortable: true},
          // { key: 'zone_name', label: '  Zone Name', sortable: true},
         
        
       ], 
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'desc',
        filter: null,
        
    }
  },
  created: function() {  
    this.displaydata();
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    
  },
  computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
  methods: {
     
    // validateForm(scope) {
    //    this.$validator.validateAll(scope).then(result => {
    //     if (result) {          
    //       this.addRackInfo();
    //     }
    //   });
    // },
    clear1: function() {},
    // rackadd: function() {
    //   this.errors.clear("form-1");
   
    //   // var allocatepin = document.getElementById('allocatepin')
    //   // allocatepin.style.display = 'none'
    //   var addrack = document.getElementById("addrack");
    //   addrack.style.display = "block";
    
    // },
    // refresh:function() {
     
    //   // var allocatepin = document.getElementById('allocatepin')
    //   // allocatepin.style.display = 'none'
    //   var addrack = document.getElementById("addrack");
    //   addrack.style.display = "none";
    //   this.clear();
    // },
   
    chkrackVal: function() {
        var length = this.items.length;       
        var needle =this.rackno.toLowerCase();
        for(var i = 0; i < length; i++) {
           // console.log(this.items[i].rackno +' '+needle);
            if(this.items[i].rackno.toLowerCase() == needle)
            { 
              return true;
            }
        }
        return false;
    },
    displaydata: function () {
      //alert("zone & pin codes");
    this.isBusy = true;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
       const obj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
      
      };




      

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/availablezonelisting`,obj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
             this.items  = result.body.returnvalue;
             // console.log(this.items);
             this.totalRows = result.body.returnvalue.length;
             this.isBusy = !this.isBusy;
          } else {
            this.items=[];
            this.totalRows =0;
               this.isBusy = !this.isBusy;
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
      downloadCSV: function() {
      document.getElementById("overlay").style.display = "block";
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
// alert("working");
 const info = {
    sysusermasterid:`${userInfo.sysusermasterid}`, 
    hub_id:`${userInfo.pickuplocationmasterid}`, 
      
      }
      // console.log(info);

      
     
      //var r = Math.random().toString(36).substring(3);
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/availablezonelistingcsv_advanced`,info)
        .then(result => {
           document.getElementById("overlay").style.display = "none";
         console.log(result.url);
           if(result.body=="success")
         {
         // alert("Please Check Ur Mail For Downlod Link")
          this.$fire({
                  text:"Please Check Ur Mail For Downlod Link",
                  type: "success",
                  timer: 30000
                }); 
       }
       else
       {
        // alert("Can not Download");
        this.$fire({
                  text:"Can not Download",
                  type: "error",
                  timer: 30000
                }); 
       }
        //window.location.href =result.url;
        });
        
    },
//      downloadCSV: function() {
      


      
     
//       //var r = Math.random().toString(36).substring(3);
// this.$http.get(`${CONSTANTS.MISREPORT_API_URL}/availablezonelistingcsv`)
//         .then(result => {
//          // console.log(result.url);
//         window.location.href =result.url;
//         });
        
//     },
    // addRackInfo: function() {
    //   var chkrackVal = this.chkrackVal();

    //   if (chkrackVal==false) {

    //     var userdata = localStorage.getItem("userData");
    //     var userInfo = JSON.parse(userdata);
    //     this.currenthubidselct=userInfo.pickuplocationmasterid.toString();  
    //     this.$validator.validateAll().then(result => {         
    //       if (result) {
    //          const rackinfosave = {
    //             hubid: `${this.currenthubidselct}`,
    //             status: 0,
    //              rack_type: 0,
    //             rackno: `${this.rackno.toLowerCase().trim()}`,      
    //           }
    //           console.log(rackinfosave);
    //         this.$http
    //           .post(
    //             `${
    //               CONSTANTS.API_URL
    //             }/DeliveryAgentMaster/RackMasterAdd`,
    //             rackinfosave
    //           )
    //           .then(result => {               
    //             if (result.body.returnmsg === "Successful") {
    //              Utils.notify("Added successfully", "success");
    //              var addrack = document.getElementById("addrack");
    //               addrack.style.display = "none";
    //               this.clear();
    //               this.displaydata();
    //               this.$router.push('/rack');
    //             } else {
    //               if (result.body.returnmsg === "unsuccessful") {
    //                 Utils.notify(result.body[0].returnvalue, "error");
    //               } else if (result.body[0].returnvalue === "0") {
    //                 Utils.notify(result.body[0].returnmsg, "error");
    //               } else {
    //                 Utils.notify(result.body[0].returnmsg, "error");
    //               }
    //             }
    //              this.$router.push('/rack');
    //           })
    //           .catch(ex => {
    //             console.log("error", ex);
    //           });
    //       } else {
    //         Utils.notify("Correct them errors", "error");
    //       }
    //     });
    //   } else {
    //     Utils.notify("This number is already exist", "error");
    //   }
    // },
     
    clear: function() {
      this.PinCodes = '';
      this.errors.clear('form-1')    
    }    
    
  }
 
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  .nameOfTheClass {
   max-width: 450px;
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
